export default __webpack_public_path__ + "static/media/page-not-found-404.ffd87715.png";